import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import personalLabelMap, { personalLabelProptypes } from 'sharedParts/config/personalLabelMap';
import questionTypes from 'sharedParts/config/questionTypes';
import RatingFormFooter from '../RatingFormFooter';
import styles from './DesktopRatingQuestionControl.scss';
import propTypeBlockStyling from '../../../../domains/styling/config/editorBlock/PropTypes/blockStyling';
import RatingScale from '../RatingScale';
import RatingNumeric from '../RatingNumeric';

const DesktopRatingQuestionControl = ({
  count,
  segmentLabelList,
  selectedItemIndex,
  personalLabelType,
  iconList,
  value,
  readOnly,
  onChange,
  max,
  min,
  block,
  block: { type, segment, size, shape },
  ratingItemClassName,
  segmentClassName,
  controlClassName,
  isTouchedOrAnswered,
  indexClassName,
  shouldHidePersonalIndex,
  styling,
}) => (
  <div>
    {type === questionTypes.questionScale || type === questionTypes.questionMatrixScale ? (
      <RatingScale
        readOnly={readOnly}
        labelType={personalLabelType}
        onChange={onChange}
        block={block}
        count={count}
        iconList={iconList}
        value={value}
        max={max}
        min={min}
        labelList={segmentLabelList}
        className={cx(controlClassName, styles.rating)}
        containerClassName={''}
        indexClassName={indexClassName}
        segmentClassName={segmentClassName}
        ratingItemClassName={ratingItemClassName}
        styling={styling}
        shouldRenderIndex={personalLabelType && personalLabelType !== personalLabelMap.noLabel}
      />
    ) : (
      <Fragment>
        <RatingNumeric
          readOnly={readOnly}
          onChange={onChange}
          iconList={iconList}
          initialValue={value}
          max={max}
          min={min}
          size={size}
          shape={shape}
          segmentLabelList={segmentLabelList}
          className={cx(controlClassName, styles.rating)}
          labelType={personalLabelType}
          count={count}
          segmentType={segment}
          containerClassName={''}
        />
        <RatingFormFooter
          shouldHideMobileSegment
          shouldHidePersonalIndex={shouldHidePersonalIndex}
          indexClassName={indexClassName}
          count={count}
          isTouchedOrAnswered={isTouchedOrAnswered}
          segmentLabelList={segmentLabelList}
          selectedItemIndex={selectedItemIndex}
          personalLabelType={personalLabelType}
          segmentClassName={segmentClassName}
          ratingItemClassName={ratingItemClassName}
          styling={styling}
          segmentType={segment}
        />
      </Fragment>
    )}
  </div>
);

DesktopRatingQuestionControl.propTypes = {
  count: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  controlClassName: PropTypes.string,
  indexClassName: PropTypes.string,
  readOnly: PropTypes.bool,
  shouldHidePersonalIndex: PropTypes.bool,
  isTouchedOrAnswered: PropTypes.bool,
  selectedItemIndex: PropTypes.number,
  iconList: PropTypes.object,
  min: PropTypes.number,
  max: PropTypes.number,
  block: PropTypes.shape({
    required: PropTypes.bool,
    shape: PropTypes.string.isRequired,
    color: PropTypes.string,
    personalLabelType: PropTypes.string,
    size: PropTypes.string,
  }).isRequired,
  personalLabelType: personalLabelProptypes,
  ratingItemClassName: PropTypes.string,
  segmentClassName: PropTypes.string,
  segmentLabelList: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, value: PropTypes.string })),
  styling: propTypeBlockStyling,
};

export default DesktopRatingQuestionControl;
